/* eslint-disable @angular-eslint/directive-selector */
import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[numbersOnly]',
  standalone: true
})
export class NumbersOnlyDirective {
  private el: NgControl;

  constructor(private ngControl: NgControl) {
    this.el = ngControl;
  }

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const value = (event.target as HTMLInputElement | null)?.value ?? '';

    if (this.el && this.el.control) {
      this.el.control.patchValue(value.replace(/[^0-9+]/g, ''));
    }
  }
}
